export type CouponKind = 'DISCOUNT_PERCENT' | 'FREE_DAYS' | string;

export type SubscriptionPlanId = 'STARTER' | 'GROWTH' | 'SCALE';

export type SubscriptionPlan = {
  id: SubscriptionPlanId;
  title: string;
  subtitle: string;
  priceCents: number;
  features: string[];
};

export type AppliedCoupon = {
  code: string;
  type: CouponKind;
  discountPercent?: number;
  freeDays?: number;
  message?: string;
  raw?: unknown;
};

export type PaymentFormData = {
  holderName: string;
  holderDocument: string;
  cardNumber: string;
  cardExpiry: string;
  cardCvv: string;
  billingZip: string;
  billingStreet: string;
  billingNumber: string;
  billingComplement: string;
  billingDistrict: string;
  billingCity: string;
  billingState: string;
};

export const createEmptyPaymentFormData = (): PaymentFormData => ({
  holderName: '',
  holderDocument: '',
  cardNumber: '',
  cardExpiry: '',
  cardCvv: '',
  billingZip: '',
  billingStreet: '',
  billingNumber: '',
  billingComplement: '',
  billingDistrict: '',
  billingCity: '',
  billingState: ''
});

export type PaymentFieldErrors = Record<string, string>;

export type PaymentNotice = {
  message?: string;
  requiresPayment?: boolean;
  paymentRequired?: boolean;
  status?: string;
  planId?: SubscriptionPlanId;
  planTitle?: string;
  reason?: string;
  trialEndsAt?: string | null;
  accessEndsAt?: string | null;
  dueAt?: string | null;
  couponCode?: string | null;
  couponType?: CouponKind | null;
  couponFreeDays?: number | null;
  [key: string]: unknown;
};
